module.exports = __webpack_public_path__ + "img/block_4.516d5a79.png";